import { jsxs as c, jsx as r, Fragment as h } from "react/jsx-runtime";
import x from "react";
import { IconChevronRight as g } from "../Icon/icons/IconChevronRight.js";
import o from "./accordion.module.js";
import { classes as u } from "../../utils/styles.js";
const k = ({
  children: i,
  header: n,
  open: s = !1,
  onToggle: t,
  titleProps: d,
  headingLevel: l,
  ...m
}) => {
  const [e, p] = x.useState(s), a = l, f = () => {
    p(!e), t && t(!e);
  };
  return /* @__PURE__ */ c("details", { open: s, ...m, children: [
    /* @__PURE__ */ c(
      "summary",
      {
        className: o.accordionHeading,
        onClick: f,
        ...d,
        children: [
          /* @__PURE__ */ r(
            g,
            {
              className: u([
                o.accordionMarker,
                ...e ? [o.open] : [o.closed]
              ]),
              role: "presentation",
              title: e ? "Sulje" : "Avaa"
            }
          ),
          a ? /* @__PURE__ */ r(a, { children: n }) : /* @__PURE__ */ r(h, { children: n })
        ]
      }
    ),
    e && /* @__PURE__ */ r("div", { className: o.accordionContent, children: i })
  ] });
};
export {
  k as Accordion
};
